import styled from "styled-components";
import {AccessibilityButton} from "../icons";

export const StyledAccessibility = styled.div`
    position: fixed;
    bottom: 2rem;
    right: 3rem;
    width: 43px !important;
    height: 43px !important;
    padding: 0;
    z-index: 10000;
`;

export const StyledAccessibilityButton = styled(AccessibilityButton)`
    width: 45px;
    height: 45px;
    position: absolute;
    top: -1px;
    left: -1px;
    color:  ${({theme}) => theme.colors.primaryT1};
`;

export const StyledAccessibilityButtonContainer = styled.button`
    width: 42px;
    height: 42px;
    padding: 0 0 0 0;
    border: 0;
    border-radius: 21px;
    cursor: pointer;
    background-color: ${({theme}) => theme.colors.primaryW};;
    position: relative;
    
    & > *:not(svg) {
        cursor: auto;
    }
`;